define('TescoMobile_Checkout/js/form/element/phone',['Magento_Ui/js/form/element/abstract'], function (Component) {
  'use strict';

  return Component.extend({
    defaults: {
      listens: {
        value: 'phoneHasChanged'
      },
      maxLength: 11
    },
    phoneHasChanged: function (value) {
      this.value(value.replace(/\s/g, ''));
    },
    valueNumber: function (event) {
      var target = event.target;
      if (target.value && target.value.length > this.maxLength) {
        target.value = target.value.slice(0, this.maxLength);
      }
    },
    valueNumberPrevent: function (event) {
      if (event.keyCode == 69) {
        event.preventDefault();
      }
    }
  });
});

